/**
 * Whether the current user may push or delete offers in the Offers grid.
 * @param {{ isAdmin?: boolean, isTapAdmin?: boolean, isTapUser?: boolean }} permissions
 * @returns {boolean}
 */
export function canManageOffers({
  isAdmin = false,
  isTapAdmin = false,
  isTapUser = false,
}) {
  return isAdmin || isTapAdmin || isTapUser;
}
